import React, { createContext, useContext, useRef } from "react";

const ContainerContext = createContext();

export function ContainerProvider({ children }) {
    const leftSideContainer = useRef();
    const rightSideContainer = useRef();

  return (
    <ContainerContext.Provider value={{ leftSideContainer, rightSideContainer }}>
      {children}
    </ContainerContext.Provider>
  );
}
export const useContainer = () => {
  const { leftSideContainer, rightSideContainer } = useContext(ContainerContext);

    return {
        leftSideContainer,
        rightSideContainer,
    };
};
export default ContainerProvider;